import * as types from "./actionTypes"

const defaultState = {}

type DefaultState = typeof defaultState

const changeMap = (
  state: DefaultState,
  action: types.MapActionTypes
): DefaultState => {
  return action.value
}

export default (
  state = defaultState,
  action: types.MapActionTypes
): DefaultState => {
  switch (action.type) {
    case types.CHANGE_MAP:
      return changeMap(state, action)

    default:
      return state
  }
}
